import React from 'react';

interface Props {
  spacing: string | number;
}

export default function Spacer({ spacing }: Props) {
  return <div style={{ height: spacing }} />;
}
